<template lang="pug" src="./templates/ProductCategoriesPage.pug"></template>

<script>
  import BreadcrumbsManager from '../../../mixins/BreadcrumbsManager';
  import PageHeader from '../../../components/layouts/PageHeader.vue';
  import TitleManager from "../../../mixins/TitleManager";
  import {RepositoryFactory} from "../../../repositoryFactory";

  const ProductCategoryRepository = RepositoryFactory.get('productCategory');

  export default {
    components: {
      PageHeader
    },
    mixins: [BreadcrumbsManager, TitleManager],
    created() {
      this.setBreadcrumbs([
        { name: 'All Categories', to: '/shop' },
      ]);
      this.getProductCategories();
    },
    data() {
      return {
        categories: []
      }
    },
    metaInfo() {
      return {
        title: 'All Categories',
      };
    },
    methods: {
      async getProductCategories() {
        const {data} = await ProductCategoryRepository.get()
          .then((resp) => resp.data);
        this.categories = data;

        Vue.nextTick(() => {
          $('.homepage-featured-category__sub-category').matchHeight();
        });
      }
    }
  }
</script>
